<template>
    <el-row v-loading="!isInitialized" style="padding:10px">
        <el-col :span="12">
            <JobFormSpecsDeliveryCategories :job-id="jobId"
                                            v-model="formValues.filters"
                                            @error="error"
                                            @input="updateFormValues"
                                            @updateOwnerOperators="updateOwnerOperators"
                                            @updateLeasePurchase="updateLeasePurchase"
                                            @updateTeam="updateTeam"
                                            @updateTanker="updateTanker"
                                            @updateHazmat="updateHazmat"
                                            @initialize="initialize"/>
        </el-col>
        <el-col :span="12">
            <JobFormSpecsDeliveryInfo :job-id="jobId"
                                      :employer-id="employerId"
                                      v-model="formValues.info"
                                      @error="error"
                                      @input="updateFormValues"
                                      @initialize="initialize"/>
        </el-col>
    </el-row>
</template>

<script>
import JobFormSpecsDeliveryCategories from './delivery/job-form-specs-delivery-categories.vue';
import JobFormSpecsDeliveryInfo from './delivery/job-form-specs-delivery-info.vue';

export default {
        components: { JobFormSpecsDeliveryCategories, JobFormSpecsDeliveryInfo },
        props: {
            jobId: { type: Number, required: true },
            employerId: { type: Number, required: true },
            value: { type: Object, required: true },
        },
        data() {
            return {
                initialized: { categories: false, info: false },
                formValues: {
                    filters: typeof this.value.filters === 'undefined' ? {} : this.value.filters,
                    info: typeof this.value.info === 'undefined' ? {} : this.value.info,
                },
            };
        },
        computed: {
            isInitialized() { return this.initialized.categories && this.initialized.info; },
        },
        methods: {
            updateFormValues() { this.$emit('input', this.formValues); },
            initialize(type) { this.$set(this.initialized, type, true); },
            error(message) { this.$emit('error', message); },
            updateOwnerOperators(value) { this.$emit('updateOwnerOperators', value); },
            updateLeasePurchase(value) { this.$emit('updateLeasePurchase', value); },
            updateTeam(value) { this.$emit('updateTeam', value); },
            updateTanker(value) { this.$emit('updateTanker', value); },
            updateHazmat(value) { this.$emit('updateHazmat', value); },
        },
    };
</script>
